<template>

  <div class="user-layout-wrapper" v-if="pageFlag == true">
    <div class="container" :style="bgStyle" v-if="isCollapse">
      <div class="logins-wraps">
        <div class="bg-left">
          <img class="bg-left-img" src="./../../../../assets/logo-left3.png" alt="">
          <div class="bg-left-first">
            欢迎登录
          </div>
          <div class="bg-left-two">
            智慧校园融合门户
          </div>

        </div>

        <div class="login-from">
          <LoginSwitch v-if="formFlag === 1" :isCollapse='isCollapse' :supportTypeList='supportTypeList' :accountPlaceholder="phonePlaceHoldText" @gotoForgetPwd='gotoForgetPwd' @afterLogin='afterLogin' @handleSubmit='handleSubmit' />
          <!-- 忘记密码 -->
          <ForgetPwd v-if="formFlag === 2" :isCollapse='isCollapse' @next='gotoLogin' />
          <LoginRoleDialog :visible.sync='selectFlag' :isPC.sync='isCollapse' :loading.sync='seletBtn' :roleList.sync='selectList' @webSelectSubmit='webSelectSubmit' @hideDialog='hideRoleDialog' />
        </div>

        <el-dialog customClass="customWidth" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
          <!-- <p style="font-size: 18px">您好！为了您的账户安全，请修改初始密码<br />如不修改则影响您的正常使用<br /><br /></p> -->
          <RestPassword @closeResetDialog="handleMessage" title="您好！为了您的账户安全，请修改初始密码，如不修改则影响您的正常使用<br>"></RestPassword>
        </el-dialog>
      </div>

    </div>

    <!-- todo app -->

    <div class="app-container" :style="bgStyle" v-else>
      <!-- <div style="color: #fff;height:100px"> {{ names }}</div> -->
      <LoginSwitch v-if="formFlag === 1" :isCollapse='isCollapse' :supportTypeList='supportTypeList' :accountPlaceholder="phonePlaceHoldText" @gotoForgetPwd='gotoForgetPwd' @afterLogin='afterLogin' @handleSubmit='handleSubmit' />
      <ForgetPwd v-else-if='formFlag === 2' :isCollapse='isCollapse' @next='gotoLogin' />
      <LoginRoleDialog :visible.sync='selectFlag' :isPC.sync='isCollapse' :loading.sync='seletBtn' :roleList.sync='selectList' @webSelectSubmit='webSelectSubmit' @hideDialog='hideRoleDialog' />

      <el-dialog customClass="customWidth" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
        <!-- <p style="font-size: 18px">您好！为了您的账户安全，请修改初始密码<br />如不修改则影响您的正常使用<br /><br /></p> -->
        <RestPassword @closeResetDialog="handleMessage" title="您好！为了您的账户安全，请修改初始密码，如不修改则影响您的正常使用<br>"></RestPassword>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import bgImage from '../../../../assets/account_login_bg.png';
import bgImageLogin from '../../../../assets/login_bg.png';
import {
  webLogin,
  checkAppToken,
  getMyUserInfo,
  getLoginManageByType
} from '@/api/api.p'
import { getQueryString, decrypt, getStorage } from '@/libs/util'
import RestPassword from '../editPass/editPass.vue'
import JSEncrypt from 'jsencrypt';
import LoginRoleDialog from '@/pages/m/views/login/loginRoleDialog.vue'
import ForgetPwd from '@/pages/m/views/login/forgetPwd.vue'
import LoginSwitch from '@/pages/m/views/login/loginSwitch.vue'

export default {
  computed: {
    bgStyle () {
      let testWidth = document.body.clientWidth
      console.log(testWidth, 'testWidth')
      let style = '';
      console.log('bgStyle:', style);
      if (testWidth > 500) {
        style = { background: `url(${this.bgImageLogin}) no-repeat 50%`, backgroundSize: 'cover' }
      } else {
        style = { background: `url(${this.bgImage}) no-repeat 50%`, backgroundSize: 'cover' }

      }
      return style;
    }
  },
  data () {
    return {
      bgImage: bgImage,
      bgImageLogin: bgImageLogin,
      names: navigator.userAgent.toLocaleLowerCase(),
      supportTypeList: [],
      isCollapse: false, // true web false app
      formFlag: 1,
      dialogFormVisible: false,
      pageFlag: false,
      selectFlag: false,
      selectList: [],
      seletBtn: false,

      // 龙岩跳转
      authorizeUrl: '', //登录完成后跳转的页面地址
      appToken: '',
      //双因子
      phonePlaceHoldText: '请输入',
      RSA: '',
      timesStart: "",

    }
  },
  components: {
    LoginSwitch,
    ForgetPwd,
    LoginRoleDialog,
    RestPassword,
  },
  beforeDestory () { },
  beforeMount () {
    console.log('beforeMount')
    if (localStorage.getItem('userUnifyToken')) {
      this.appToken = localStorage.getItem('userUnifyToken') ? localStorage.getItem('userUnifyToken') : ''
    }
  },
  created () {


    this.timesStart = new Date().getTime()

    if (getQueryString('loginCode')) {
      this.pageFlag = false
      let loginCode = getQueryString('loginCode')
      let loginName = getQueryString('loginName')
      let password = decodeURIComponent(loginCode); // 登录密码验证码
      let username = decodeURIComponent(loginName); // 登录账号


      // console.log(this.model.password, 'loginCode')
      let loginTypeIndexHold = getQueryString('loginType'); // 登录方式：0：游客登录；1：一键登录；2：密码登录；3：验证码登录
      let params = {
        "agree": "1",//
        //密码ζ验证码
        "loginCode": password,
        "loginName": username,
        "loginType": loginTypeIndexHold,
      }

      if (getQueryString('authorizeUrl')) {
        this.authorizeUrl = getQueryString('authorizeUrl')
      }
      this.handleSubmit(params)

    } else {
      let ua = navigator.userAgent.toLocaleLowerCase()
      console.log(ua, 'uas')
      let list = ua.split(' ');
      let appId = ''
      for (let i = 0; i < list.length; i++) {
        if (list[i].match(/appid/) || list[i].match(/appId/)) {
          appId = list[i].slice(6)
        }
      }

      if (appId != '') {

        sessionStorage.setItem('appId', appId)
        localStorage.setItem('appId', appId)
        window.nativeCallJsSchemeUserAuth = this.nativeCallJsSchemeUserAuth;
        nativeKysk.nativeUserAuthFunKysk('nativeCallJsSchemeUserAuth', 1)
      }


      if (localStorage.getItem('userUnifyToken')) {
        this.checkAppToken()
      }

      console.log(localStorage.getItem('userUnifyToken'), '==')

      if (getQueryString('authorizeUrl') && localStorage.getItem('userUnifyToken')) {
        this.pageFlag = false
      } else {
        this.pageFlag = true
      }
    }




  },
  mounted () {

    if (getQueryString('loginCode')) {

    } else {
      if (localStorage.getItem('userUnifyToken')) {

      } else {
        this.getLoginManage();
        let pass = getStorage('login_password')
        if (pass != null) {
          pass = decrypt(pass)
        }
        let account = getStorage('login_account')
        if (account != null) {
          account = decrypt(account)
        }
        this.dialogFormVisible =
          localStorage.getItem('userUnifyInfo') &&
          account &&
          account.length > 0 &&
          (localStorage.getItem('isDefaultPwd') == true || localStorage.getItem('isDefaultPwd') == 'true')
      }

      this.setPageW()

    }
  },
  methods: {
    nativeCallJsSchemeUserAuth (val) {

      localStorage.setItem('userUnifyToken', val)
      sessionStorage.setItem('userUnifyToken', val);
      this.$nextTick(() => {
        if (val) {

        } else {
          this.$router.push({
            name: 'authority',
          })
        }
      })


    },
    // 初始化 appId - 从 userAgent 中解析
    initAppId () {
      let ua = navigator.userAgent.toLocaleLowerCase()
      console.log(ua, 'uas')
      let list = ua.split(' ');
      let appId = ''
      for (let i = 0; i < list.length; i++) {
        if (list[i].match(/appid/) || list[i].match(/appId/)) {
          appId = list[i].slice(6)
        }
      }

      if (appId != '') {
        sessionStorage.setItem('appId', appId)
        localStorage.setItem('appId', appId)
      }
    },
    async getLoginManage () {
      const res = await getLoginManageByType()
      if (res && res.meta) {
        if (res.meta.code === 0) {
          this.phonePlaceHoldText = res.data.codeName;
          this.RSA = res.data.loginSecret
          let code = res.data.code;
          let codeList = code.split(',');
          this.supportTypeList = codeList.length > 0 ? codeList : [];
        } else {
          this.$toast(res.meta.message);
        }
      } else {
        this.$toast('操作失败');
      }
    },
    handleMessage (event) {
      localStorage.setItem('isDefaultPwd', false)
      this.dialogFormVisible = false
      this.seletBtn = false
      if (getQueryString('authorizeUrl')) {
        this.authorizeUrl = getQueryString('authorizeUrl')
        if (localStorage.getItem('userUnifyToken')) {
          this.checkAppToken()
        }
        // return
      }
    },
    checkAppToken () {
      let params = {
        appToken: localStorage.getItem('userUnifyToken') ? localStorage.getItem('userUnifyToken') : '',
      }
      checkAppToken(params)
        .then((res) => {
          var isDefaultPwd = localStorage.getItem('isDefaultPwd') == true || localStorage.getItem('isDefaultPwd') == 'true'
          if (res.meta.code == 0) {

            // && isDefaultPwd == false

            let data = localStorage.getItem('userUnifyToken') ? localStorage.getItem('userUnifyToken') : '';
            let authorizeUrl = ''
            if (getQueryString('authorizeUrl')) {
              authorizeUrl = getQueryString('authorizeUrl');
              let urlData = unescape(authorizeUrl)
              let urls = urlData
              if (urls.includes('?')) {
                //console.log('URL中包含问号');
                urls = urls + '&appToken=' + data
              } else {
                urls = urls + '?appToken=' + data
              }

              console.log(urls, 'urlData')


              window.location.href = urls
              console.log(urls, 'urls')
              // window.location.href = unescape(unescape(urls))
              localStorage.setItem('isDefaultPwd', false)
            } else {
              if (isDefaultPwd == false) {
                this.$route({
                  name: 'home'
                })
              } else {
                //改密码
              }

            }

          } else {
            sessionStorage.removeItem('userUnifyToken')
            localStorage.removeItem('userUnifyToken')
            window.location.reload()
          }
        })
        .catch((err) => {
          console.log('rrr')
          sessionStorage.removeItem('userUnifyToken')
          localStorage.removeItem('userUnifyToken')
          window.location.reload()
        })
    },
    gotoLogin (value) {
      console.log('gotoLogin: value = ', value);
      this.formFlag = 1
    },
    // 切换窗口
    gotoForgetPwd () {
      console.log('gotoForgetPwd 3');
      this.formFlag = 2
    },
    // 监听浏览器宽度
    setPageW () {
      let testWidth = document.body.clientWidth
      console.log(testWidth, 'testWidth')
      if (testWidth > 500) {
        this.isCollapse = true
      } else {
        this.isCollapse = false
      }
    },
    afterLogin (data, index) {
      sessionStorage.setItem('userUnifyToken', data.token)
      sessionStorage.setItem('isDefaultPwd', data.isDefaultPwd)

      localStorage.setItem('userUnifyToken', data.token)
      localStorage.setItem('isDefaultPwd', data.isDefaultPwd)

      if (index == 2) {
        if (data.isDefaultPwd == true) {
          this.selectFlag = false;
        }
      }
      this.dialogFormVisible = data.isDefaultPwd || false;

      if (data.sidList && data.sidList.length > 0) {

      } else {
        this.getMyUserInfo();
      }

      if (data.isDefaultPwd != true) {
        if (data.sidList && data.sidList.length > 0) {
          this.showSelectRoleDialog(data.sidList);
        } else {
          this.$nextTick(() => {
            if (getQueryString('authorizeUrl')) {
              this.authorizeUrl = getQueryString('authorizeUrl')
              if (data.token) {
                this.checkAppToken()
              }
            } else {
              localStorage.setItem('isDefaultPwd', false)
              this.$router.push({
                name: 'home',
              })
            }
          })
        }
      }
    },
    //登录
    handleSubmit (param) {
      if (getQueryString('loginCode')) {

      } else {
        const publicKey = this.RSA // 从服务器端获取到RSA加密公钥
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publicKey)
        const originalData = param.loginCode;
        const encryptedData = encrypt.encrypt(originalData)
        console.log(this.authorizeUrl, encryptedData)
        param.loginCode = encryptedData
        if (this.authorizeUrl != '') {
          param.agree = this.authorizeUrl;
        }
      }

      webLogin(param)
        .then((res) => {
          if (res.meta.code == 0) {
            if (getQueryString('loginCode')) {
              let data = res.data;
              sessionStorage.setItem('userUnifyToken', data.token)
              sessionStorage.setItem('isDefaultPwd', data.isDefaultPwd)
              localStorage.setItem('userUnifyToken', data.token)
              localStorage.setItem('isDefaultPwd', data.isDefaultPwd)

              if (getQueryString('authorizeUrl')) {
                this.authorizeUrl = getQueryString('authorizeUrl')
                if (data.token) {
                  this.checkAppToken()
                }
              } else {
                localStorage.setItem('isDefaultPwd', false)
                this.$router.push({
                  name: 'home',
                })
              }
            } else {
              this.afterLogin(res.data);
            }

          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
        })
    },
    showSelectRoleDialog (roleList) {
      this.selectList = roleList;
      this.selectFlag = true;
    },
    hideRoleDialog () {
      this.selectList = [];
      this.selectFlag = false;
    },
    // web选择身份登录
    webSelectSubmit (userId) {
      let params = {
        agree: '1', // 如果不是开发者,是否同意成为开发者(0=不同意,1=同意)
        loginCode: localStorage.getItem('userUnifyToken'), // 登录密码验证码
        loginName: userId, // 登录账号
        loginType: '4', // 登录方式：0：游客登录；1：一键登录；2：密码登录；3：验证码登录
      }

      if (this.authorizeUrl != '') {
        params.agree = this.authorizeUrl;
      }
      webLogin(params)
        .then((res) => {
          if (res.meta.code == 0) {
            this.afterLogin(res.data, 2)

          } else {
            document.getElementById("roleErrorTips").innerHTML = res.meta.message;
            this.seletBtn = false
          }
        })
        .catch((err) => {
          this.seletBtn = false
        })
    },
    getMyUserInfo () {
      getMyUserInfo()
        .then((res) => {
          if (res.meta.code == 0) {
            window.sessionStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
            localStorage.setItem('userUnifyInfo', JSON.stringify(res.data))
          } else {
            this.$toast(res.meta.message)
          }
        })
        .catch((err) => {
          this.$toast(err.meta.message)
        })
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep.el-input--prefix {
  .el-input__inner {
    padding-left: 40px !important;
  }
}
.user-layout-wrapper {
  height: 100%;

  // web
  .container {
    width: 100%;
    // min-height: 100%;
    height: 100vh;
    background: #f0f2f5 url('../../../../assets/login_bg.png') no-repeat 50%;
    background-size: cover;
    // padding: 110px 0 144px;
    position: relative;

    .logins-wraps {
      width: 825px;
      display: flex;
      position: absolute;
      top: 50%;
      height: 468px;
      margin-top: -234px;
      left: 50%;
      margin-left: -412.5px;
    }
    .codes-box {
      width: 100%;
      display: flex;
      .codes-left {
        flex: 1;
      }
      .code-btn {
        flex: 1;
        text-align: right;
        cursor: pointer;
        color: #606266;
        font-weight: 500;
        font-size: 14px;
      }
    }

    .logo {
      width: 230px;
      height: 88px;
      position: absolute;
      top: 70px;
      left: 80px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    a {
      text-decoration: none;
    }

    .bg-left {
      width: 385px;
      height: 468px;
      background: url('./../../../../assets/bg-left@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      .bg-left-img {
        width: 188px;
        height: 74px;
        margin-top: 80px;
      }
      .bg-left-first {
        font-size: 30px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        padding-top: 50px;
      }
      .bg-left-two {
        font-size: 30px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        padding-top: 25px;
      }
    }
    .main {
      // min-width: 260px;
      // width: 368px;
      // margin: 0 auto;
      // flex: 1;
      width: calc(825px - 375px); /* 20px是绝对定位元素的宽度 */
      background: #fff;
      border-radius: 8px;
      padding: 40px 40px 54px 40px;
      position: absolute;
      left: 375px;
      height: 468px;
      overflow: hidden;
      // box-shadow: 0px 0px 30px 0px rgba(104, 104, 104, 0.14);

      // margin-top: -200px;

      .login-title {
        font-size: 20px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 500;
        color: #999999;

        text-align: center;
        padding-bottom: 38px;
        width: 100%;
      }
      .tabs-div {
        // flex: 1;
        cursor: pointer;
      }
      .divclors {
        color: #4086f6;
        position: absolute;
      }
      .divclors::after {
        content: '';
        position: absolute;
        bottom: -12px;
        left: 25%;
        // margin-left: -30px;
        width: 60px;
        height: 2px;
        background: #4086f6;
        border-radius: 1px;
      }

      .user-layout-login {
        .item-first {
          margin-bottom: 30px;
        }

        label {
          font-size: 14px;
        }

        .form-bottom {
          position: relative;

          .pass-text {
            // position: absolute;
            // bottom: 40px;
            // right: 0;
            color: #4086f6;
            font-size: 12px;
            cursor: pointer;
            text-align: right;
          }
        }

        button.login-button {
          padding: 0 15px;
          font-size: 16px;
          height: 40px;
          width: 100%;
          margin-top: 20px;
        }
      }
      .pc-pass {
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    // @media (max-width:500px) {

    // }
    // @media (min-width:500px) {
    //   .logo {
    //     width: 322px;
    //     height: 100px;
    //     position: absolute;
    //     top: 70px;
    //     left: 80px;

    //     img {
    //       height: 100%;
    //       width: 100%;

    //     }
    //   }
    // }
    /deep/.el-input__inner {
      // border: none !important;
      background: #fff;
      color: #202020 !important;
    }

    .el-button--primary {
      background: #4086f6;
    }

    .el-button {
      border: none;
    }

    /deep/.el-input-group__append {
      border: none;
      background: #f5f5f5;
      color: #4086f6;
      font-size: 14px;

      .code-text {
        cursor: pointer;
      }

      .code-timer {
        color: #999;
      }
    }
  }

  // app
  /deep/.app-container {
    width: 100%;
    // min-height: 100%;
    height: 100vh;
    // background: #f0f2f5 url('../../../../assets/account_login_bg.png') no-repeat 50%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 30px;

    .logo {
      margin-top: 101px;
      width: 75px;
      height: 75px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .content {
      width: 100%;
      padding-top: 49px;

      .app-form-login {
        /deep/.el-input-group--prepend {
          border: 1px solid #f2f2f2;
          // border-radius: 22px;
          border-radius: 8px;
          height: 44px;
          display: flex;
        }

        .input-icon {
          /deep/.el-input-group__prepend,
          /deep/.el-input-group__append {
            min-width: 42px;
            // height: 44px;
            // border-radius: 22px 0 0 22px;
            border-radius: 8px 0 0 8px;
            padding: 0;
            background: rgba(245, 245, 245, 0.2);
            border: none;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #f2f2f2;
          }

          /deep/.el-input-group__append {
            // border-radius: 0 22px 22px 0;
            border-radius: 0 8px 8px 0;

            .code-timer {
              color: #999;
            }
          }

          /deep/.el-input__inner {
            border: none !important;
            background: rgba(245, 245, 245, 0.2);
            // border-radius: 0 22px 22px 0;
            border-radius: 0 8px 8px 0;
            height: 100%;
            color: #fff;
            font-size: 18px;
          }
        }

        .input-icon-two {
          /deep/.el-input__inner {
            border: none !important;
            background: rgba(245, 245, 245, 0.2);
            border-radius: 0;
            height: 100%;
            color: #fff;
            font-size: 18px;
          }
        }

        .input-icon-tree {
          /deep/.el-input-group__append {
            color: #fff;
            font-size: 15px;
            width: auto;
            min-width: auto;
            padding-right: 15px;

            .code-timer {
              color: #999;
            }
          }
        }

        .input-icon-up {
          width: 16px;
          height: 16px;
          margin-top: -4px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .form-bottom {
          .pass-text {
            text-align: right;
            color: #bfbfbf;
            padding-right: 10px;
          }

          .login-button {
            width: 100%;
            background: #fff;
            // border-radius: 22px;
            border-radius: 8px;
            color: #4086f6;
            font-size: 16px;
            height: 44px;
            border-color: #fff;
          }
        }
      }
    }

    .main {
      min-width: 340px;
      margin: 20px;
      background: #fff;
      border-radius: 10px;
      padding: 20px 20px 20px 20px;
      box-shadow: 0px 0px 30px 0px rgba(104, 104, 104, 0.14);
      //position: absolute;
    }

    /deep/.el-input__inner {
      &::placeholder {
        font-size: 16px;
      }
    }
  }

  /deep/.login-from {
    width: calc(825px - 375px); /* 20px是绝对定位元素的宽度 */
    background: #fff;
    border-radius: 8px;
    position: absolute;
    left: 375px;
    height: 468px;
    overflow: hidden;

    .login-from-box {
      width: 100%;
      background: #ffffff;
      border-radius: 10px;
      padding: 0 60px;

      .el-header {
        padding: 0 !important;
        height: 98px !important;
      }

      .el-main {
        padding: 0 !important;
      }
      .el-footer {
        padding: 0 !important;
        height: 62px !important;
      }

      .form-login-header {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 98px;
      }

      .form-login-main {
        position: absolute;
        top: 98px;
        left: 60px;
        right: 60px;
        bottom: 62px;
      }

      .form-login-footer {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
      }

      .form-header {
        padding-top: 8px;
        width: 100%;
        align-content: center;

        .header-title {
          text-align: center;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 600;
          line-height: 36px;
          display: flex;

          .tabs-selected {
            flex: 1;
            color: #4086f6;
            cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 10px;
            text-decoration-thickness: 2px;
          }

          .tabs-normal {
            flex: 1;
            cursor: pointer;
          }

          .tabs-div {
            flex: 1;
            cursor: pointer;
          }
          .divclors {
            color: #4086f6;
            cursor: pointer;
          }
          .divclors::after {
            content: '';
            position: absolute;
            //bottom: -12px;
            left: 25%;
            // margin-left: -30px;
            width: 60px;
            height: 2px;
            background: #4086f6;
            border-radius: 1px;
          }
          .tabs-only-one {
            flex: 1;
            color: #4086f6;
            cursor: pointer;
          }
        }
      }

      .form-body {
        .form-login-body {
          margin: 0;
        }
        .login-meta {
          padding-bottom: 20px;

          .wrap-input {
            width: 100%;
            height: 48px !important;
            border-radius: 4px;
            border: 1px solid #d9d9d9;

            .el-input input:-webkit-autofill {
              -webkit-box-shadow: none !important;
              box-shadow: none !important;
              background-color: transparent !important;
              transition: background-color 50000s ease-in-out 0s;
              font-size: 16px !important;
              caret-color: #fff;
            }

            .el-input-group--prepend {
              height: 46px;
              display: flex;

              .el-input-group__prepend {
                min-width: 40px !important;
                padding: 0;
                background: transparent !important;
                border: none;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .input-icon-up {
                width: 16px;
                height: 16px;
                margin-top: -4px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .el-input__inner {
                padding-left: 0;
                border: none !important;
                background: transparent !important;
                height: 46px !important;
                line-height: 46px !important;
                color: var(--global-color-a);
                font-size: 16px;
                &::placeholder {
                  font-size: 14px;
                }
              }

              .el-input-group__append {
                width: auto;
                min-width: auto;
                padding: 0 15px;
                background: transparent !important;
                border: none;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;

                .pass-switch {
                  width: 16px;
                  height: 16px;
                  margin-top: -4px;

                  img {
                    filter: var(--global-color-e);
                    width: 100%;
                    height: 100%;
                  }
                }

                .code-btn {
                  font-size: 14px;
                  cursor: pointer;
                  color: var(--global-theme-color);
                }

                .code-count-down {
                  font-size: 14px;
                  color: #999;
                }
              }
            }

            input {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }

            .code-btn {
              font-size: 14px;
              color: var(--global-theme-color);
              cursor: pointer;
            }

            .code-count-down {
              font-size: 14px;
              color: var(--global-color-c);
            }
          }

          .wrap-input-focus {
            border: 1px solid var(--global-theme-color);
          }
        }

        .login-meta-before-radio {
          padding-bottom: 14px;
        }

        .login-meta-before-code {
          padding-bottom: 0;
        }

        .code-radio-group {
          width: 100%;
          display: flex;

          .code-radio-item {
            height: 34px;
            line-height: 34px;
          }

          .code-radio-item:first-child {
            flex: 1;
          }

          .code-radio-item:last-child {
            text-align: right;
            flex: 1;
          }

          .el-radio__input.is-checked + .el-radio__label {
            color: var(--global-theme-color) !important;
          }

          .el-radio__input.is-checked .el-radio__inner {
            background: var(--global-theme-color) !important;
            border-color: var(--global-theme-color) !important;
          }
        }

        .login-btn {
          width: 100%;
          height: 48px;
          text-align: center;

          border-radius: 4px;
          background: var(--global-theme-color);
          border: none;
          cursor: pointer;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }

      .code-label {
        height: 20px;
        font-size: 12px;
        text-align: right;

        .code-label-tips {
          color: var(--global-color-d);
        }

        .code-label-error {
          color: red;
        }
      }

      .form-bottom {
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: right;
        height: 55px;
        font-size: 12px;
        width: 100%;

        .form-switch {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          cursor: pointer;
          color: var(--global-color-a);
        }
      }

      .bottom-pwd {
        height: 26px;
        width: 100%;
        display: flex;

        .el-checkbox__input.is-checked + .el-checkbox__label {
          color: var(--global-theme-color) !important;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: var(--global-color-b) !important;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: var(--global-theme-color) !important;
          border-color: var(--global-theme-color) !important;
        }

        .remember-pass {
          flex: 1;
          color: var(--global-color-b);
        }
        .pass-text {
          flex: 1;
          text-align: right;
          color: var(--global-color-b);
        }
      }

      .form-bottom-switch {
        margin-right: 60px;
      }
    }
  }

  /deep/.app-login-from-box {
    width: 100%;
    height: 100%;

    .el-input__inner {
      height: 46px !important;
      line-height: 46px !important;
      font-size: 18px;
      &::placeholder {
        font-size: 16px;
      }
    }

    .el-header {
      padding: 20px 0 !important;
      height: 175px !important;
    }

    .el-main {
      padding: 0 !important;
    }
    .el-footer {
      padding: 0 !important;
      height: 62px !important;
    }

    .form-login-header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 175px !important;
      display: flex;
      justify-content: center !important; /* 水平居中 */
      align-items: end !important; /* 底部对齐 */
    }

    .form-login-main {
      position: absolute;
      top: 175px;
      left: 30px;
      right: 30px;
      bottom: 62px;
    }

    .form-login-footer {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
    }

    .form-body {
      .form-login-body {
        margin: 0;
      }
      .login-meta {
        padding-bottom: 20px;

        .el-form-item__error {
          margin-top: 5px;
          margin-left: 10px;
        }

        .wrap-input {
          width: 100%;
          height: 48px !important;
          border-radius: 22px;
          background: rgba(245, 245, 245, 0.2);
          border: 1px solid #f2f2f2;

          .el-input input:-webkit-autofill {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            -webkit-text-fill-color: #fff !important;
            background-color: transparent !important;
            transition: background-color 50000s ease-in-out 0s;
            font-size: 18px !important;
            caret-color: #fff;
          }

          .el-input-group--prepend {
            height: 44px;
            display: flex;

            .el-input-group__prepend {
              min-width: 46px !important;
              padding: 0;
              background: transparent !important;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
              border-right: 1px solid #f2f2f2;
            }

            .input-icon-up {
              width: 16px;
              height: 16px;
              margin-top: -4px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .el-input__inner {
              border: none !important;
              background: transparent !important;
              height: 100%;
              color: #fff;
              font-size: 18px;
              &::placeholder {
                font-size: 16px;
              }
            }

            .el-input-group__append {
              width: auto;
              min-width: auto;
              padding: 0 15px;
              background: transparent !important;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;

              .code-btn {
                font-size: 14px;
                cursor: pointer;
                color: #fff;
              }

              .code-count-down {
                font-size: 14px;
                color: #999;
              }
            }
          }

          input {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .code-btn {
            font-size: 14px;
            color: var(--global-theme-color);
            cursor: pointer;
          }

          .code-count-down {
            font-size: 14px;
            color: var(--global-color-c);
          }
        }
      }

      .login-meta-before-radio {
        padding-bottom: 14px;
      }

      .login-meta-before-code {
        padding-bottom: 0;
      }

      .code-radio-group {
        width: 100%;
        padding: 0 10px;
        display: flex;

        .code-radio-item {
          height: 34px;
          line-height: 34px;
        }

        .code-radio-item:first-child {
          flex: 1;
        }

        .code-radio-item:last-child {
          text-align: right;
          flex: 1;
        }

        .el-radio__input + .el-radio__label {
          color: var(--global-color-e) !important;
        }

        .el-radio__input.is-checked + .el-radio__label {
          color: var(--global-color-e) !important;
        }

        .el-radio__input.is-checked .el-radio__inner {
          background: var(--global-theme-color) !important;
          border-color: var(--global-theme-color) !important;
        }
      }

      .login-btn {
        width: 100%;
        background: #fff;
        // border-radius: 22px;
        border-radius: 8px;
        color: #4086f6;
        font-size: 16px;
        height: 44px;
        border-color: #fff;
      }
    }

    .code-label {
      height: 20px;
      margin-top: 5px;
      margin-right: 10px;
      font-size: 12px;
      text-align: right;

      .code-label-tips {
        color: #fff;
      }

      .code-label-error {
        color: red;
      }
    }

    .bottom-pwd {
      width: 100%;
      display: flex;

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: var(--global-color-e) !important;
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: var(--global-theme-color) !important;
        border-color: var(--global-theme-color) !important;
      }

      .remember-pass {
        padding-left: 5px;
        flex: 1;
        color: var(--global-color-e);
      }
      .pass-text {
        flex: 1;
        text-align: right;
        color: var(--global-color-e);
        padding-right: 10px;
      }
    }

    .form-bottom {
      .login-button {
        width: 100%;
        background: #fff;
        // border-radius: 22px;
        border-radius: 8px;
        color: #4086f6;
        font-size: 16px;
        height: 44px;
        border-color: #fff;
      }
    }
  }

  /deep/.union-all-web {
    .el-form-item {
      margin-bottom: 0;
    }
    .form-login-body {
      margin: 0 !important;
    }
  }

  /deep/.union-one-web {
    .el-form-item {
      margin-bottom: 0;
    }
    .form-login-body {
      margin: 0 !important;
    }
  }

  /deep/.non-union-web {
    .el-form-item {
      margin-bottom: 0;
    }
    .form-login-body {
      margin-top: 40px !important;
    }
  }

  /deep/.union-all-app {
    width: 100%;
    height: 100%;

    .el-form-item {
      margin-bottom: 0;
    }
    .form-login-body {
      margin: 0 !important;
    }
  }
}

/deep/.app-logo {
  width: 75px;
  height: 75px;

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/.app-switch {
  position: absolute;
  top: 30px;
  right: 30px;
  color: #fff;
  text-align: right;
}

/deep/.app-qr-btn {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  cursor: pointer;
  color: #bfbfbf;
  text-align: end;
}
</style>
<style>
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}
.customWidth {
  width: 440px;
}
</style>
